import React from 'react'
import img1 from '../../../../../assets/images/muvibus/d01.jpg'
import img2 from '../../../../../assets/images/muvibus/d02.jpg'
import img3 from '../../../../../assets/images/muvibus/d03.jpg'

import { DestinationsContainer } from './styles.style'

const DestinationsPage = () => {
	var currentDate = new Date().toISOString().slice(0, 10);
	return (
		<DestinationsContainer>
			<div className="title-info">
				Conheça nossos destinos!
			</div>
			<div className="images">
				<div>
					<a href={`compra-de-passagem?Origem=SANTA%20MARIA%20(RS)&Destino=PORTO%20ALEGRE%20(RS)&IdOrigem=15956&IdOrigemIBGE=431690705060001&IdDestino=15921&IdDestinoIBGE=431490205000001&Empresa=Planalto&DataIda=${currentDate}&PortalOrigem=Muviflex`} target="_blank">
						<img
							src={img1}
							alt="Santa Maria (RS) x Porto Alegre (RS) x Santa Maria (RS)"
						/>
					</a>
				</div>
				<div>
					<a href={`compra-de-passagem?Origem=ALEGRETE%20(RS)&Destino=PORTO%20ALEGRE%20(RS)&IdOrigem=16655&IdOrigemIBGE=430040605060001&IdDestino=15921&IdDestinoIBGE=431490205000001&Empresa=Planalto&DataIda=${currentDate}&PortalOrigem=Muviflex`} target="_blank">
						<img
							src={img2}
							alt="Alegrete (RS) x Porto Alegre (RS) x Alegrete (RS)"
						/>
					</a>
				</div>
				<div>
					<a href={`compra-de-passagem?Origem=URUGUAIANA%20(RS)&Destino=PORTO%20ALEGRE%20(RS)&IdOrigem=15923&IdOrigemIBGE=432240005000001&IdDestino=15921&IdDestinoIBGE=431490205000001&Empresa=Planalto&DataIda=${currentDate}&PortalOrigem=Muviflex`} target="_blank">
						<img
							src={img3}
							alt="Uruguaiana (RS) x Porto Alegre (RS) x Uruguaiana (RS)"
						/>
					</a>
				</div>
			</div>
		</DestinationsContainer>
	)
}

export default DestinationsPage
